<procure-card
  class="search-overlay"
  condensed
  [loading]="isLoading()"
>
  @if (hasSearchTerm()) {
    <div class="header">
      <mat-button-toggle-group
        class="toggle-group"
        [formControl]="activeEntityControl"
      >
        @for (tab of tabs(); track tab) {
          <mat-button-toggle
            [class]="`toggle ${tab.entityType}`"
            [value]="tab.entityType"
            [matTooltip]="tabTooltips[tab.entityType ?? ''] || ''"
          >
            {{ tab.name }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
  }
  <procure-search-results class="results" />
  @if (hasSearchTerm()) {
    <procure-search-filters class="filters" />
  }
</procure-card>
